import './Theme/plugins/fancybox/jquery.fancybox.css';
import './Theme/css/css.css';
import './Theme/css/font-awesome-4.7.0/css/font-awesome.min.css';
import './Theme/css/animate.css';
import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import 'slick-carousel/slick/slick.css';
import Header from './Header';
import Menu from './CommonMenu';
import NhacPhatGiaoPageApi from './NhacPhatGiaoPageApi';
import { FILE_URL } from './Constants';
import logoSmall from "./Theme/img/linhqquylogo-small.jpg";
import $ from 'jquery';
window.jQuery = $;
require('textillate');
require('letteringjs');
require('slick-carousel');


function NhacPhatGiaoPage() {
  const [searchParams] = useSearchParams();
  const [danhmuc, setDanhmuc] = useState([]);
  const [data, setData] = useState([]);
  const [detailData, setDetailData] = useState(null);
  const catId = searchParams.get('catId');
  const postId = searchParams.get('postId');
  const title = searchParams.get('title');

  useEffect(() => {
    $('.tlt').textillate({
      loop: true,
      minDisplayTime: 20000,
      in: { effect: 'fadeIn', delayScale: 3, shuffle: false },
      out: { effect: 'fadeOut', delayScale: 1.5, delay: 100, sync: false, shuffle: false, reverse: false }
    });

    $("#sky-bg").fadeIn(2e3);

    NhacPhatGiaoPageApi.getAllType().then((res) => {
      setDanhmuc(res);
    }).catch((error) => {
      console.error("Failed to fetch types:", error);
    });

    if (postId) {
        NhacPhatGiaoPageApi.getDataByPostId(postId).then((res) => {
            if (Array.isArray(res) && res.length > 0) {
                setDetailData(res[0]);
            } else {
                setDetailData(res);
            }
        });
    } else if (catId === null) {
      NhacPhatGiaoPageApi.getAllData().then((res) => {
        setData(res);
      })
    } else {
      NhacPhatGiaoPageApi.getListByCat(catId).then((res) => {
        setData(res);
      })
    }

  }, [catId, postId]);

  return (
    <div>
      <meta httpEquiv="Content-Type" content="text/html; charset=UTF-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />
      <meta httpEquiv="Content-Language" content="vi" />
      <title>{detailData?.Title || "Nhạc Phật Giáo"} | Linh Quy Pháp Ấn</title>
      <link rel="shortcut icon" href="/Upload/images/tab/logochuan.jpg" type="image/png" />
      
      <div className="fly-text">
        <ul>
          <li className="tlt">Nguyện thành tựu</li>
          <li className="tlt">Lòng tin bất động</li>
          <li className="tlt">Nơi Đức Phật, Chánh Pháp</li>
          <li className="tlt">Chúng Tăng và Thánh Giới</li>
        </ul>
      </div>
      <div id="sky-bg">
        <div className="clouds_one" />
        <div className="clouds_two" />
        <div className="clouds_three" />
      </div>
      <Header />

      <section>
        <div className="container contentContainer">
          <div className="row news-list">
            <div className="col-md-9 col-sm-9 col-xs-12">
              <Menu value={"nhacphat"} />
              
              {postId ? (
                 <div className="detail-music" style={{marginTop: '20px'}}>
                    <h1 style={{color: '#80271A', borderBottom: '2px solid #FFD21D'}}>{detailData?.Title}</h1>
                    <div className="row" style={{marginTop: '20px'}}>
                        <div className="col-md-5">
                            <img src={FILE_URL + detailData?.Thumb} alt={detailData?.Title} style={{width: '100%', borderRadius: '8px'}} />
                        </div>
                        <div className="col-md-7">
                            <div className="music-player-box" style={{background: '#f9f9f9', padding: '20px', borderRadius: '8px', border: '1px solid #ddd'}}>
                                <h4>Đang phát: {detailData?.Title}</h4>
                                <p>Lượt xem: {detailData?.ViewedCount}</p>
                                <audio controls autoPlay style={{width: '100%', marginTop: '10px'}}>
                                    <source src={FILE_URL + detailData?.Value} type="audio/mpeg" />
                                    Your browser does not support the audio element.
                                </audio>
                                <div style={{marginTop: '20px'}}>
                                    <h5>Mô tả:</h5>
                                    <p>{detailData?.Description}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="music-content" style={{marginTop: '30px'}} dangerouslySetInnerHTML={{__html: detailData?.Content}}></div>
                 </div>
              ) : (
                <>
                    <h1>{title || "NHẠC PHẬT GIÁO"}</h1>
                    {
                        catId === null ? (
                            data && Object.keys(data).length > 0 ? (
                                Object.keys(data).map((category, index) => (
                                    <div className="homeKinhSach" key={index}>
                                    <h3>
                                        <a href={`/nhac-phat-giao?title=${category}&catId=${data[category][0]?.Id_Cat || ""}`}>
                                        {category}
                                        </a>
                                    </h3>
                                    <div className="row">
                                        {data[category].map((item, idx) => (
                                        <a
                                            key={idx}
                                            className="col-md-3 col-sm-6 itemHomeListVideo itemHomeListBook itemNhacPhatBao"
                                            href={`/nhac-phat-giao?postId=${item?.id}`}
                                            style={{ paddingBottom: '10px' }}
                                        >
                                            <div className="containerOverlay">
                                            <img
                                                className="thumbHover"
                                                alt={item.Title} title={item.Title} src={FILE_URL + item.Thumb}
                                            />
                                            <p className="titleNhacPhatBao">{item.Title}</p>
                                            </div>
                                        </a>
                                        ))}
                                    </div>
                                    </div>
                                ))
                            ) : <p>Đang tải dữ liệu...</p>
                        ) : (
                        Array.isArray(data) && data.length > 0 ? (
                            data.map((item, index) => (
                                <div className="list-news" key={index}>
                                <div className="media">
                                    <div className="media-left">
                                    <a href={`/nhac-phat-giao?postId=${item?.id}`}>
                                        <img className="media-object" src={FILE_URL + item.Thumb} alt={item.Title} title={item.Title} style={{width: '150px'}} />
                                    </a>
                                    </div>
                                    <div className="media-body">
                                    <h4 className="media-heading">
                                        <a href={`/nhac-phat-giao?postId=${item?.id}`}>
                                        <h3 style={{ borderBottom: '2px solid #FFD21D' }}>{item.Title}</h3>
                                        </a>
                                    </h4>
                                    {item.Description}
                                    <br /><br />
                                    <b>Lượt xem: {item.ViewedCount}</b>
                                    <br /><br />
                                    <a href={`/nhac-phat-giao?postId=${item?.id}`} className="btn btn-warning btnsize">Xem chi tiết & Nghe</a>
                                    </div>
                                </div>
                                </div>
                            ))
                        ) : <p>Không có dữ liệu cho danh mục này.</p>
                        )
                    }
                </>
              )}

            </div>
            <div className="col-md-3 col-sm-3 col-xs-12">
              <div className="row">
                <div className="col-md-12 col-sm-12 col-xs-12  none-padding-left  boxNews">
                  <div className="containerRightBox">
                    <h5 className="titleRightHome">DANH MỤC NHẠC</h5>
                    <ul className="nav nav-pills nav-stacked listDanhMuc">
                      {danhmuc?.map((item, index) => (
                        <li key={index}>
                          <a href={`/nhac-phat-giao?title=${item.Name}&catId=${item.Id}`}>
                            <i className="fa fa-angle-right" /> {item.Name}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="footer-copyright">
        <div className="container">
          <div className="row">
            <div className="col-md-1">
              <img className="img-responsive" src={logoSmall} alt="Logo" />
            </div>
            <div className="col-md-5">
              Copyright © 2011 - 2024<br />Linhquyphapan.vn, All right reserved <br />Chủ nhiệm: Thượng Toạ Thích Minh Thành
            </div>
            <div className="col-md-6">
              Thôn 4 - Xã Lộc Thành - Huyện Bảo Lâm - Tỉnh Lâm Đồng <br />SĐT: 0963 232 651 , 0766 522 181<br />Email: linhquyphapan@yahoo.com <br /> www.linhquyphapan.vn
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default NhacPhatGiaoPage;
